module.exports = __webpack_public_path__ + "static/media/ic_home.6c05d229.svg";